import Space from './src/main'

Space.install = function (Vue) {
  Vue.component(Space.name, Space)
}

export default Space
